// extracted by mini-css-extract-plugin
module.exports =  {"container":"LivvHt2S","heading":"m4A9A_Vj","headingCopy":"vLWuVyqZ","headingPill":"QuG89T_a","subheading":"zVU58P_6","infoBox":"eFt5tbIl"};